import { CommonAPIService } from './CommonHandler';

export class ClaimAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/claims`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  create(claim, router) {
    const url = `/api/claims`;
    return this.CommonAPIService.postCall(url, claim, router);
  }
  delete(id, router) {
    const url = `/api/claims/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }
  update(id, claim, router) {
    const url = `/api/claims/${id}`;
    return this.CommonAPIService.putCall(url, claim, router);
  }
}

export default ClaimAPIService;
